import React from 'react';
import { Route } from 'react-router';

import { LoadableHealthcheck } from './helpers/loadables';

export default (
  <>
    {/* Healthcheck */}
    <Route path="/healthcheck" component={LoadableHealthcheck} />
  </>
);
